import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { map, Observable } from 'rxjs';
import { UserService } from 'src/app/modules/shared/services/user.service';
import { MANUAL_LOGOUT_STORAGE_KEY } from 'src/app/authentication.constants';

@Component({
    selector: 'account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccountComponent {
  @Input() isExpanded: boolean;

  userName: Observable<string>;

  constructor(userService: UserService,
    private authService: MsalService) {
    this.userName = userService.getUser().pipe(map(user => user?.name));
  }

  logout() {
    sessionStorage.setItem(MANUAL_LOGOUT_STORAGE_KEY, 'true');
    this.authService.logoutRedirect().subscribe({
      error: error => {
        sessionStorage.removeItem(MANUAL_LOGOUT_STORAGE_KEY);
        console.error('AAD logout failed.', error);
      }
    });
  }
}
